import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"padding":"0 10px"} }
const _hoisted_2 = { style: {"margin-bottom":"36px","margin-top":"-10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_AddUniComponent = _resolveComponent("AddUniComponent")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_section_divider, null, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "el-icon-document" }, null, -1)),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$filters.capitalize("Education Info")), 1),
        (_ctx.index > 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeEducation(_ctx.index))),
              icon: "el-icon-delete",
              circle: "",
              size: "mini"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      prop: "organisation",
      label: "College/University"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { justify: "space-between" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 22 }, {
              default: _withCtx(() => [
                (_ctx.universities && _ctx.universities.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      "w-100": "",
                      modelValue: _ctx.form.organisation,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.organisation) = $event)),
                      onChange: _ctx.setValue,
                      filterable: "",
                      "filter-method": _ctx.uniSearchMethod,
                      placeholder: "EX: African Leadership University"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.value,
                            value: option.value,
                            label: option.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "filter-method"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_AddUniComponent, {
                  onCreated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createdUni($event)))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "degree",
              label: "Degree"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.degree,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.degree) = $event)),
                  onChange: _ctx.setValue,
                  placeholder: "Bachelor's",
                  "w-100": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.universityLevels, (level) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: level.name,
                        label: level.name,
                        key: `${level.name}-ind`
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "program",
              label: "Program/Certification"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "Comp Science",
                  modelValue: _ctx.form.program,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.program) = $event)),
                  onChange: _ctx.setValue,
                  "w-100": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantPrograms, (program) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: program,
                        label: program,
                        key: `${program}-ind`
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "From",
              label: "Start Date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "month",
                  format: "MM/YYYY",
                  placeholder: "MM/YYYY",
                  modelValue: _ctx.form.from,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.from) = $event)),
                  onChange: _ctx.setValue
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.stillThere !== true)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "To",
                  label: "End Date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      type: "month",
                      format: "MM/YYYY",
                      placeholder: "MM/YYYY",
                      modelValue: _ctx.form.to,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.to) = $event)),
                      onChange: _ctx.setValue
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_checkbox, {
                onChange: _cache[7] || (_cache[7] = ($event: any) => {if (_ctx.stillThere) _ctx.form.to = undefined;}),
                modelValue: _ctx.stillThere,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.stillThere) = $event)),
                label: "Currently at the College/University.",
                size: "small"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ])), [
    [_directive_loading, _ctx.loadingUniversities]
  ])
}